export default "__VITE_ASSET__Dlm144U5__"